import { useEffect, useState } from "react"
import { Box, Typography } from "@mui/material"
import useAppStore from "store/app"
import useTranslation from "hooks/use_translation"

import Layout from "./Layout"
import Navigation from "./Navigation"
import Screening from "components/containers/Screening"
import NoClientData from "../../containers/NoClientData"

const LastScreening = () => {
  const [screening, setScreening] = useState("")

  const getClientAnamneses = useAppStore((state) => state.getClientAnamneses)
  const { pages } = useTranslation()

  useEffect(() => {
    getClientAnamneses().then((response) => {
      const lastId = response.data[0]?.uuid

      setScreening(lastId)
    })
  }, [])

  return (
    <Layout>
      <Box
        sx={{
          backgroundColor: "bg.light",
          p: 1,
          display: "flex",
          flexDirection: "column",
          mb: 6,
        }}
      >
        <Typography variant="h5" sx={{ mb: 2.5, fontWeight: 700 }}>
          {pages?.last_screening?.title}
        </Typography>

        {screening ? (
          <Screening screening_id={screening} />
        ) : (
          <NoClientData description={pages?.last_screening?.no_data} />
        )}
      </Box>

      <Navigation />
    </Layout>
  )
}

export default LastScreening
